export enum Routes {
  Search = '/search',
  Backoffice = '/backoffice',
  Blog = '/blog',
  Blogs = '/blogs',
  Home = '/home',
  Homes = '/homes',
  Experiences = '/experiences',
  TourIframe = '/tours',
  // TODO: Change route search to route hotel on the entire site
  ThreeDS = '/three-ds',
  Error = '/error',
  BasicError = '/error/generic',
  CustomError = '/error/message',
  NotAuthorized = '/error/not-authorized',
  NotFound = '/error/404',
  Cruises = '/cruise',
  Flights = '/flights',
  Cars = '/car',
  Dashboard = '/dashboard',
  Getaway = '/getaway',
  Getaways = '/getaways',
  GetawayCondo = '/getaway/condo',
  GetawayCondos = '/getaway/condos',
  GetawayStaycation = '/getaway/staycation',
  GetawayList = '/getaway/list',
  GetawayDetails = '/getaway/details',
  GetawayBookingPage = '/getaway-booking',
  SearchResult = '/result',
  Hotel = '/hotel',
  AllInclusive = '/all-inclusives',
  AllInclusivesSubmitRequest = '/all-inclusives/submit-request',
  Book = '/book',
  Condo = '/condo',
  CondosMap = '/condos/world-map',
  CondosWeeks = '/condos/weeks',
  CondosWeeklySpecials = '/condos/weekly-specials',
  Widget = '/widget',
  SearchHotelWidget = '/widget/search/hotel',
  
  LuxuryHomes = '/luxury-homes/home',
  LuxuryHomesList = '/luxury-homes/list',
  LuxuryHomesDetails = '/luxury-homes/details',
  LuxuryHomesCheckout = '/luxury-homes/checkout',
  LuxuryHomesPlace = '/luxury-homes/place',

  CarsSearch = '/cars/search',
  CarsDetails = '/cars/details',
  CarsBook = '/cars/book',

  WeeksSearch = '/weeks/search',
  WeeksDetails = '/weeks/details',
  WeeksBook = '/weeks/book',

  CondoSearch = '/condo/deals',
  UnitBook = '/unit-book',
  Login = '/signin',
  Logout = '/signout',
  SignUp = '/signup',
  VerifyUser = '/verify',
  SendVerifyEmail = '/send-verify',
  ForgotPassword = '/password/forgot',
  ResetPassword = '/password/reset',
  ChangePassword = '/password/change',
  RequestCancelReservation = '/request-cancel-reservation',
  ReservationCancellation = '/reservation-cancellation',
  AmericanLifestyle = '/magazine',
  ConciergeTeam = '/concierge-travel-team',
  MemberStories = '/member/stories',
  Resources = '/travel-resources',
  DailyBenefits = '/daily-benefits',
  MemberVideos = '/member/videos',
  ContactUs = '/contact-us',
  MasterClassesRegister = '/master-classes-register',
  PersonalInfo = '/personal-info',
  Security = '/security',
  PromotionDetails = '/promotion',
  PrivacyPolicy = '/privacy-policy',
  PriceMatch = '/price-match',
  BrioRci = '/brio-rci',
  BrioRciHowTo = '/brio-rci/how-to',
  Elite = '/elite',
  NewMembers = '/newmembers',
  EliteRciHowTo = '/elite-rci/how-to',
  Webinars = '/webinars',
  Faq = '/faq',
  Reservations = '/reservations',
  RsiAccount = '/account',
  AccountReservations = '/account/reservations',
  RsiTestDriveManager = '/account/test-drive-manage',
  RsiQuotes = '/account/quotes',
  SavedPropertiesAccount = '/saved-properties',
  SavedProperties = '/account/saved-properties',
  SidekickRewards = '/sidekick-rewards',
  SidekickRewardsTerms = '/sidekick-rewards/terms',
  SidekickRewardsPrivacy = '/sidekick-rewards/privacy',

  MLMBecomeAgent = '/become-agent',
  MLMNewAgents = '/new-agents',
  MLMExperiencedAgents = '/experienced-agents',
  MLMExclusiveAccess = '/exclusive-access',
  MLMTraining = '/training',
  MLMTechnology = '/technology',

  InsuranceSearch = '/insurance/search',
  Campings = '/campings',
  CampingsWelcome = '/campings/welcome',
  CampingsFAQs = '/campings/faqs',
  CampingsBookingHowTo = '/campings/booking-how-to',
  MarketingSpecials = '/marketingspecials',
}

export enum Urls {
  Users = '/users',
  UsersCards = '/users/paymentmethod',
  SSO = '/sso',
  Accounts = '/account',
  GoogleLogin = '/identity/users/login-with-google',
  Hotels = '/Hotels/search/page',
  Locations = '/Locations',

  CarsLocations = '/cars/locations',
  CarsSearch = '/cars/search',
  CarsDetails = '/cars/recheck',
  CarsCheckout = '/cars/checkout',
  CarsCheckoutResume = '/cars/book-resume',

  NavigationItems = '/account/menu',
  Suppliers = '/suppliers',
  HotelDetails = '/hotels/hotel',
  BookingSummary = '/hotels/hotel/booking-summary',
  BookPackageWithCard = '/hotels/book-package-with-card',
  BookPackageWithCardResume = '/hotels/book-resume',
  HotelsMap = '/hotels/search/area',
  HotelRedeemCode = '/hotels/redeem-code',
  HotelRemoveCode = '/hotels/cancel-redeem-code',
  HotelAutocomplete = '/hotels/hotel/autocomplete',
  reservationCancellationDetails = '/bookings/reservation-details',
  cancelReservation = '/bookings/cancel-reservation',
  requestCancelReservation = '/bookings/request-cancel',
  HotelsRecentSearches = '/hotels/recent-searches',
  HotelTopDeals = '/hotels/top-deals',
  HotelRooms = '/hotels/search/id',

  WalletUser = '/wallet/byuserId',

  LuxuryHomes = '/condos/luxury',
  LuxuryHomesDetailsRates = '/property',
  LuxuryHomesDetailsUnavailableDates = '/property',

  Quotes = '/deals/quote',
  MarketingWeeks = '/deals/prequote-availabity',
  MarketingWeeksLocations = '/condos/locations/GetPlaceLocationCondoPrequote',

  getReservations = '/bookings/browsebookingbyuser',
  getContentByPropertyId = '/bookings/content',
  reservationsSearchText = '/bookings/bookingsearch',
  reservationsCancel = '/bookings/cancel',
  reservationsSendVoucher = '/bookings/voucher',
  DownloadVoucher = '/bookings/bookings',
  QuotesHontelsDownload = '/bookings/quotes/download',
  QuotesCarsDownload = '/bookings/quotes/cars/download',
  QuotesHotelsShare = '/bookings/quotes/share',
  QuotesCarsShare = '/bookings/quotes/cars/share',

  QuotesWeeksDownload = '/bookings/quotes/weeks/download',
  QuotesWeeksShare = '/bookings/quotes/weeks/share',

  QuotesCondosDownload = '/bookings/quotes/condo/download',
  QuotesCondosShare = '/bookings/quotes/condo/share',

  getTravelHistory = '/sso/browsetravelhistorybyuser',
  ssoMember = '/sso/member',
  bookingManual = '/manualbooking',

  GetHotels = '/api/hotels',

  TrustYou = 'https://api.trustyou.com/hotels',
  Deals = '/deals',
  Getaways = '/deals',
  GetawaysMLM = '/deals/geolocations',
  CurrentUser = '/sso/currentuser',
  Benefits = '/sso/benefits',

  Currencies = '/currencies',

  CondosRecommendedLocations = '/condos/locations/recommended',
  CondosRecentSearches = '/condos/recent-searches',
  CondosLocationsPopularDestinations = '/condos/locations/popular',
  CondosLocations = '/condos/locations',
  CondosSearchStrict = '/condos/search/strict',
  CondosSearchStrictPagination = '/condos/search/strict/page',
  CondosSearchFlexible = '/condos/search/flexible',
  CondosSearchFlexiblePagination = '/condos/search/flexible/page',
  CondosSearchAnytime = '/condos/search/anytime',
  CondosSearchAnytimePagination = '/condos/search/anytime/page',
  CondoDetails = '/condos/details',
  CondoBook = '/condos/book',
  CondoBookResume = '/condos/book-resume',
  CheckinStatus = '/condos/checkin-status',
  CondoUnits = '/condos/search/units',
  CondoCountries = '/condos/countries',
  CondoBookingSummary = '/condos/booking-summary',
  CondoAllDestinations = '/condos/locations/alldestinations',

  WeeksSearch = '/property/search/week/page',
  WeeksDetails = '/property/week/details',
  WeeksBookingSummary = '/property/booking-summary',
  WeeksBook = '/property/book',
  WeeksBookResume = '/property/book-resume',
  WeeksUnitSearch = '/property/search/units',

  AllInclusiveDestinations = '/locations/allinclusive',

  CondoRedeemCode = '/api/condos/redeem-code',
  CondoRemoveCode = '/api/condos/cancel-redeem-code',

  InsuranceGetQuote = '/insurance/quote',
  InsuranceCheckout = '/insurance/checkout',

  Magazine = '/external/magazine',
  NotificationBar = '/external/notification-bar',
  MemberStories = '/external/member-stories',

  Slides = '/external/slides',
  Promotions = '/promotions',
  PromotionsExternal = '/external/slides',
  MemberVideos = 'https://rsistaticdata.s3.amazonaws.com/membervideos',
  PersonalDetails = '/api/sso/personal-details',

  DashboardReports = '/bookings/reporttravelagenthome',
  CURRENCY_CONVERT= '/pricings/CurrencyExchange/CurrencyCalculator',
}
